import { render } from "./SeasonDetail.vue?vue&type=template&id=2501c688&bindings={\"year\":\"props\"}"
import script from "./SeasonDetail.vue?vue&type=script&lang=ts"
export * from "./SeasonDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script